import type { Permission } from '@shared/types';

export interface NavItem {
  to: string;
  label: string;
  /** 需要的权限位；用户不具备时该入口不渲染 */
  permission: Permission;
  description: string;
  /** 侧栏图标（内联 SVG path，避免引入图标库） */
  icon: string;
}

export const NAV_ITEMS: readonly NavItem[] = [
  {
    to: '/fleet',
    label: '机队总览',
    permission: 'fleet.view',
    description: '全部无人机的位置、航线与关键指标',
    icon: 'M12 2 4 6v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10V6l-8-4Zm0 2.3 6 3V12c0 3.9-2.6 6.8-6 8-3.4-1.2-6-4.1-6-8V7.3l6-3Z',
  },
  {
    to: '/fleet/drones',
    label: '无人机管理',
    permission: 'fleet.registry.view',
    description: '注册信息、接入鉴权与批量配置',
    icon: 'M4 6h16v4H4V6Zm0 8h16v4H4v-4Zm2-6v.5h.5V8H6Zm0 8v.5h.5V16H6Z',
  },
  {
    to: '/fleet/tracking',
    label: '单机管理',
    permission: 'fleet.telemetry.view',
    description: '单机实时姿态、链路与指令',
    icon: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 2a7 7 0 0 1 7 7h-2a5 5 0 0 0-5-5V5Zm0 14a7 7 0 0 1-7-7h2a5 5 0 0 0 5 5v2Z',
  },
  {
    to: '/users',
    label: '用户管理',
    permission: 'user.view',
    description: '平台用户、角色与权限分配',
    icon: 'M12 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 10c4 0 7 2 7 4.5V20H5v-2.5C5 15 8 13 12 13Z',
  },
  {
    to: '/audit',
    label: '审计日志',
    permission: 'audit.view',
    description: '所有敏感操作的留痕',
    icon: 'M6 3h9l5 5v13H6V3Zm8 1.5V9h4.5L14 4.5ZM9 12h6v1.5H9V12Zm0 4h6v1.5H9V16Z',
  },
  {
    to: '/settings',
    label: '系统设置',
    permission: 'settings.manage',
    description: '平台参数、告警阈值与数据保留',
    icon: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm9 4c0 .6-.06 1.2-.17 1.76l2.02 1.5-2 3.46-2.34-.98a9 9 0 0 1-3.05 1.76L15 21h-4l-.46-2.5a9 9 0 0 1-3.05-1.76l-2.34.98-2-3.46 2.02-1.5a9.1 9.1 0 0 1 0-3.52L3.15 7.74l2-3.46 2.34.98A9 9 0 0 1 10.54 3.5L11 1h4l.46 2.5a9 9 0 0 1 3.05 1.76l2.34-.98 2 3.46-2.02 1.5c.11.56.17 1.16.17 1.76Z',
  },
];
